<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Bunch"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <el-steps class="stepper-container" :active="highlightedStep" align-center finish-status="success">
                <el-step v-for="(step, index) in steps" :key="'step' + index" :title="step.name" :description="step.description" />
            </el-steps>

            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>QR Code</td>
                        <td>{{ qrCode }}</td>
                    </tr>
                    <tr>
                        <td>Bag Number</td>
                        <td>{{ detailInfo.bagNumber || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Palm</td>
                        <td>{{ palmPassport }}</td>
                    </tr>
                    <tr>
                        <td>Bunch Weight / kg</td>
                        <td>{{ detailInfo.bunchWeightKG || "-" }}</td>
                    </tr>

                    <tr>
                        <td class="table-section" colspan="2">Crossing</td>
                    </tr>
                    <tr>
                        <td>Pollen Bottle</td>
                        <td>{{ pollenBottleQRCode  || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Pollen</td>
                        <td>{{ pollenQRCode  || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Crossing Date</td>
                        <td>{{ $_getMyrDateFormat(detailInfo.pollinateDate) || "-" }}</td>
                    </tr>
                    
                    <tr>
                        <td class="table-section" colspan="2">Status</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>{{ (detailInfo.bunchStatus||{}).name || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { bunchGet } from "@/api/bunch";

export default {
    components: {
        "detail-header": DetailHeader,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null,
            detailSteps: [
                { name: "Bagging", dateKey: "bagDate", employeeKey: "bagEmployee" },
                { name: "Crossing", dateKey: "pollinateDate", employeeKey: "pollinateEmployee" },
                { name: "Tagging", dateKey: "tagDate", employeeKey: "tagEmployee" },
                { name: "Harvesting", dateKey: "harvestDate", employeeKey: "harvestEmployee" },
                { name: "Chopping", dateKey: "chopDate", employeeKey: "chopEmployee" },
                { name: "Seperating", dateKey: "separateDate", employeeKey: "separateEmployee" },
                { name: "Depericaping", dateKey: "depericarpDate", employeeKey: "depericarpEmployee" }
            ]
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo.qrCode ? `${this.detailInfo?.qrCode?.code}` : "";
        },
        pollenBottleQRCode() {
            return this.detailInfo?.pollenBottle?.qrCode?.code || "-"
        },
        pollenQRCode() {
            return this.detailInfo?.pollenBottle?.pollen?.qrCode?.code || "-"
        },
        palmPassport() {
            return this.arrangePassportFormat(this.detailInfo?.palm?.trial, this.detailInfo?.palm?.trialPalmNumber, this.detailInfo?.palm?.progeny);
        },
        crossType() {
            return this.detailInfo?.palm?.progeny?.crossType?.name || "-"; 
        },
        steps() {
            return this.detailSteps.map(step => ({
                "name": step.name,
                "description": this.getRecordDateAndUser(this.detailInfo[step.dateKey], this.detailInfo[step.employeeKey]),
                "value": this.getIsHavingRecord(this.detailInfo[step.dateKey])
            }));
        },
        highlightedStep() {
            let lastHighlightedIndex = -1;
            this.steps.forEach((step, index) => {
                if (step.value === true) {
                    lastHighlightedIndex = index;
                }
            });
            return lastHighlightedIndex == -1 ? 0 : lastHighlightedIndex + 1;;
        } 
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        getRecordDateAndUser(recordDate, recordUser) {
            let date = this.$_getMyrDateFormat(recordDate);
            let user = recordUser?.name || "-";
            // return {
            //     "display": `${date} by ${user}`,
            //     "value": recordDate ? 1 : 0
            // };
            return `${date} by ${user}`;
        },
        getIsHavingRecord(recordDate) {
            if (recordDate) {
                return true;
            }
            else return false;
        },
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await bunchGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    },
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-12) 0;
    margin-bottom: var(--space-12);
    width: 360px;
    overflow-x: scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/BunchSidebar.vue